import React from 'react';
import {Row} from 'react-table';
import {Prelead} from 'api';

interface Props {
  row: Row<Prelead>;
  value: any;
}

const CustomizeItemNumberCell = ({row, value}: Props) => {
  const prelead: Prelead = row.original;
  const clientPreleadCustomizeItemId = value;

  const customizeItem = React.useMemo(
    () =>
      prelead.customizeItemNumbers.find(
        (item) =>
          item.clientPreleadCustomizeItemId === clientPreleadCustomizeItemId,
      ),
    [prelead, clientPreleadCustomizeItemId],
  );

  return customizeItem?.value?.toLocaleString() || null;
};

export default CustomizeItemNumberCell;
